import { render, staticRenderFns } from "./HistoryPacking.vue?vue&type=template&id=6d859b26&"
import script from "./HistoryPacking.vue?vue&type=script&lang=js&"
export * from "./HistoryPacking.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPacking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports